import { render, staticRenderFns } from "./NsTopnavSection.vue?vue&type=template&id=43fd7f68&scoped=true&"
import script from "./NsTopnavSection.vue?vue&type=script&lang=js&"
export * from "./NsTopnavSection.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavSection.vue?vue&type=style&index=0&id=43fd7f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fd7f68",
  null
  
)

export default component.exports